const SDK_VERSION = "10.63.0" ;

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
